import React, { useState } from "react";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";
import { IoIosCloseCircle } from "react-icons/io";
import { FaHome } from "react-icons/fa";
import { FaClipboardList } from "react-icons/fa";
import { FaHeartbeat } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getSessionContext } from "../../common/utils/sessionContext";

const FamilySidebar = (props) => {
  const navigate = useNavigate();
  const { appVersion, familyClientName } = getSessionContext();
  const restrictMenu = Boolean(props.restrictMenu);
  const [state, setState] = useState({
    top: false,
    left: true,
    bottom: false,
    right: false,
  });

  const releaseDrawerFocus = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const closeDrawer = () => {
    releaseDrawerFocus();
    props?.showHamBergIcon?.();
  };

  const handleLogoutClick = () => {
    releaseDrawerFocus();
    props?.showHamBergIcon?.();
    props.onLogoutClick?.();
  };

  const handleChangePage = (path) => {
    navigate(path);
    closeDrawer();
  };

  const toggleDrawer = (anchor, open) => (event) => {
    if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const allMenuItems = [
    { label: "Home", path: "/family-home", icon: FaHome },
    { label: "Checklist", path: "/family-checklist", icon: FaClipboardList },
    { label: "Vitals", path: "/family-vitals", icon: FaHeartbeat },
  ];
  const menuItems = restrictMenu ? allMenuItems.filter((item) => item.label === "Home") : allMenuItems;

  const list = () => (
    <Box className="family-sidebar-drawer" sx={{ width: 370, height: "100%" }} role="presentation">
      <List className="sidebar-header">
        <img src={require("../../assets/btTree.png")} alt="BridgeTree" />
        <div className="logo-sidebar">
          <img src={require("../../assets/footer-BTName.png")} alt="BridgeTree" />
        </div>
        <div className="close-icon">
          <Tooltip title="Close Menu" arrow>
            <span>
              <IoIosCloseCircle className="close-icon-inner" onClick={closeDrawer} />
            </span>
          </Tooltip>
        </div>
      </List>

      {familyClientName && !restrictMenu ? (
        <div className="family-sidebar-client-label">
          <span>Viewing</span>
          <strong>{familyClientName}</strong>
        </div>
      ) : null}

      <List className="sidebar-menu">
        {menuItems.map(({ label, path, icon: Icon }) => (
          <React.Fragment key={path}>
            <ListItem disablePadding onClick={() => handleChangePage(path)}>
              <ListItemButton>
                <ListItemIcon>
                  <Icon className="caregiver-sidemenu-icon" />
                </ListItemIcon>
                <ListItemText primary={label} className="sidebar-menu-text" />
              </ListItemButton>
            </ListItem>
            <Divider className="menu-line" />
          </React.Fragment>
        ))}
      </List>

      <div className="family-sidebar-footer">
        <div className="header-menu-button">
          <button type="button" className="ccar-logout-button" onClick={handleLogoutClick}>
            LOGOUT
          </button>
        </div>
        <div className="sidebar-version">Version {appVersion || "2.0.0"}</div>
      </div>
    </Box>
  );

  return (
    <div>
      {["left"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer anchor={anchor} open={state[anchor]} onClose={closeDrawer} onOpen={toggleDrawer(anchor, true)} PaperProps={{ className: "family-sidebar-drawer-paper", sx: { overflow: "hidden" } }}>
            {list()}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
};

export default FamilySidebar;
